export const putScrollbarSizeInCSSVariable = () => {
  let timeout = false
  const delay = 250

  window.addEventListener('resize', () => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      document.documentElement.style.setProperty('--scrollbarsize', `${window.innerWidth - document.documentElement.clientWidth}px`)
    }, delay)
  })

  setTimeout(() => {
    document.documentElement.style.setProperty('--scrollbarsize', `${window.innerWidth - document.documentElement.clientWidth}px`)
  }, 0)
}

export const removeOnloadHiddenStatus = (selector = '[data-hidden-onload]') => {
  const elements = document.querySelectorAll(selector)
  if (elements.length) {
    elements.forEach((element) => {
      element.removeAttribute('style')
    })
  }
}
